import { Pipe, PipeTransform } from '@angular/core';
import { TaskStage, TASK_STAGES } from '../enums/task-stage';

@Pipe({
  name: 'readableTaskStage'
})
export class ReadableTaskStagePipe implements PipeTransform {

  public transform(value: TaskStage | string, args?: any): string {

    if (!value) {
      return '';
    }

    const label = TASK_STAGES.find(stage => stage.value === value.toString());
    // If there's no label, return what we passed
    if (!label) {
      return value;
    }

    return label.label;
  }

}
